import styled, { css } from "styled-components";
import { glow } from "../../styles/global";


export const FileWrapperOverLay = styled.div`
   position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.5); 
`;


export const FileWrapper = styled.div<{ loading?: boolean }>`
  display:block;
  position:relative;
  padding: 10px;
  border-radius: 5px;
  width:fit-content;
  overflow:hidden;

  ${({ loading }) =>
    loading &&
    css`
      & > * {
        border: 2px solid rgba(0, 150, 255, 0.8);
        animation: ${glow} 1.5s infinite alternate;
      }
    `}

    &:hover ${FileWrapperOverLay} {
    visibility: visible;
  }

`;

